var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-common-space c-responsive-fixwidth c-common-gradient c-common-box-shadow c-radius3",staticStyle:{"margin-left":"10px","margin-top":"80px"}},[_c('div',{staticClass:"col-md-12 no-job-dispaly"},[_vm._v("\n        "+_vm._s("You don't have Access to this page")+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04b20981","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotAllowed.vue
// module id = null
// module chunks = 